import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportRoutingModule } from './report-routing.module';
import { ReportListComponent } from './report-list/report-list.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    ReportRoutingModule,
    FormsModule,
    NgbModule
  ],
  declarations: [ReportListComponent]
})
export class ReportModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/report/report.module.ts